const IssuePriorityDescEnum = Object.freeze({
  0: 'niski',
  1: 'średni',
  2: 'wysoki',
  3: 'pali się'
});

export default IssuePriorityDescEnum;
